import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BlobFileDownloadRequestModel } from '../../models/blob-file-sas-url.model';
import { MSAIDownloadCSV } from '../../models/msai-download-csv.model';
import { IncentiveReadyforPayment } from '../../models/si-ready-for-payment.model';
import { SettingsService } from '../common/settings.service';

@Injectable({
  providedIn: 'root'
})
export class MSAIDownloadReportService {
  constructor(
    private http: HttpClient,
    public settings: SettingsService
  ) {}

  getMSAIDownloadCSVFilesList(): Observable<MSAIDownloadCSV[]> {
    return this.http.get<MSAIDownloadCSV[]>(
      this.settings.baseUrl +
        'api/M365acceleratorNominations/GetMSAIDownloadCSVList'
    );
  }

  getMSAIDownloadCSVFile(
    downloadModal: BlobFileDownloadRequestModel
  ): Observable<string> {
    return this.http.post<string>(
      this.settings.baseUrl + 'api/M365acceleratorNominations/DownloadCSVFile',
      downloadModal
    );
  }

  getMSAIPReadyforPaymentReport(
    hasPayeeId: boolean
  ): Observable<IncentiveReadyforPayment[]> {
    return this.http.get<IncentiveReadyforPayment[]>(
      this.settings.baseUrl +
        'api/M365acceleratorNominations/GetAdvisorIncentiveReadyforPaymentReport/hasPayeeId/' +
        hasPayeeId
    );
  }
}
